import { isObject, isUndefinedOrNull } from "./utils/utils"

export type CamelCaseObjectKeys<T> = {
    [key in keyof T as Uncapitalize<key & string>]: T[key] extends object ? CamelCaseObjectKeys<T[key]> : T[key]
}

export function camelCaseKeys<T>(obj: T): CamelCaseObjectKeys<T> {
    return changeCase(obj, s => s.toLowerCase())
}

export type PascalCaseObjectKeys<T> = {
    [key in keyof T as Capitalize<key & string>]: T[key] extends object ? PascalCaseObjectKeys<T[key]> : T[key]
}

export function pascalCaseKeys<T>(obj: T): PascalCaseObjectKeys<T> {
    return changeCase(obj, s => s.toUpperCase())
}

function changeCase<T>(obj: T, transform: (arg: string) => string) {

    if (isUndefinedOrNull(obj)) {
        return obj
    }

    const entries = Object.entries(obj)
    const mappedEntries = entries.map(
        ([k, v]) => [
            `${transform(k.substring(0, 1))}${k.substring(1)}`,
            isObject(v)
                ? changeCase(v, transform)
                : v
        ]
    )

    return Object.fromEntries(mappedEntries)

}
